module.exports = __webpack_public_path__ + "static/media/curve2-gr.420b4e74.svg";